import Swiper from "swiper";
import { A11y, Autoplay } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-benefits .callouts").forEach((el) => {
  const container = el.querySelector(".swiper");

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay],
    autoplay: {
      delay: 1500,
    },
    speed: 750,
    loop: true,
    slidesPerView: 3,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 5,
        enabled: false,
        loop: false,
      },
    },
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
